import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../index";

interface ResearchGapHeatmapState {
  // Map of threadInteractionId to maximum value seen
  maxValues: Record<string, number>;
}

const initialState: ResearchGapHeatmapState = {
  maxValues: {},
};

const researchGapHeatmapSlice = createSlice({
  name: "researchGapHeatmap",
  initialState,
  reducers: {
    updateMaxValue(
      state: ResearchGapHeatmapState,
      { payload }: PayloadAction<{ threadInteractionId: string; value: number }>
    ) {
      const { threadInteractionId, value } = payload;
      const currentMax = state.maxValues[threadInteractionId] || 0;
      state.maxValues[threadInteractionId] = Math.max(currentMax, value);
    },
    resetMaxValue(
      state: ResearchGapHeatmapState,
      { payload }: PayloadAction<string>
    ) {
      delete state.maxValues[payload];
    },
    clearAllMaxValues(state: ResearchGapHeatmapState) {
      state.maxValues = {};
    },
  },
});

// Actions
export const { updateMaxValue, resetMaxValue, clearAllMaxValues } =
  researchGapHeatmapSlice.actions;

// Selectors
export const selectMaxValue = (state: RootState, threadInteractionId: string) =>
  state.researchGapHeatmap.maxValues[threadInteractionId] || 0;

export const selectAllMaxValues = (state: RootState) =>
  state.researchGapHeatmap.maxValues;

export default researchGapHeatmapSlice.reducer;
